var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "font-small-3 text-bold-700 p-05 d-block",
        class: _vm.classes,
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.toggle.apply(null, arguments)
          },
          mouseover: function ($event) {
            _vm.hover = true
          },
          mouseleave: function ($event) {
            _vm.hover = false
          },
        },
      },
      [
        _c("i", { staticClass: "fa fa-thumbs-o-up" }),
        _vm._v(" "),
        _c("span", {
          domProps: { textContent: _vm._s(_vm.count === 0 ? "" : _vm.count) },
        }),
      ]
    ),
    _vm._v(" "),
    _vm.hover && _vm.likedUsersList.length > 0
      ? _c(
          "div",
          {
            staticClass: "likes-dropdown dropdown-menu-center",
            attrs: { "aria-labelledby": "dropdownLikesList" },
            on: {
              mouseover: function ($event) {
                _vm.hover = true
              },
              mouseleave: function ($event) {
                _vm.hover = false
              },
            },
          },
          [_c("LikedByList", { attrs: { likedByUsers: _vm.likedUsersList } })],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }